import * as THREE from "three"

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import RAF from '../utils/RAF'
import config from '../utils/config'
import MyGUI from '../utils/MyGUI'

import simpleFrag from '../shaders/simple.frag'
import simpleVert from '../shaders/simple.vert'
import World from "./meshes/World"
import Physics from "./physics/World"
// src/classes/meshes/World.js

class MainThreeScene {
    constructor() {
        this.bind()
        this.camera
        this.scene
        this.renderer
        this.controls
    }

    init(container) {
        //RENDERER SETUP
        this.renderer = new THREE.WebGLRenderer({ antialias: true })
        this.renderer.setSize(window.innerWidth, window.innerHeight)
        this.renderer.debug.checkShaderErrors = true
        container.appendChild(this.renderer.domElement)

        //MAIN SCENE INSTANCE
        this.scene = new THREE.Scene()

        //CAMERA AND ORBIT CONTROLLER
        this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000)
        this.camera.position.set(0, 10, 40)
        this.controls = new OrbitControls(this.camera, this.renderer.domElement)
        this.controls.enabled = config.controls
        this.controls.maxDistance = 1500
        this.controls.minDistance = 0

        //DUMMY CUBE + SIMPLE GLSL SHADER LINKAGE
        const shaderMat = new THREE.ShaderMaterial({
            vertexShader: simpleVert,
            fragmentShader: simpleFrag,
        })
        const cube = new THREE.Mesh(new THREE.BoxGeometry(), shaderMat)
        // this.scene.add(cube)

        MyGUI.hide()
        if (config.myGui)
            MyGUI.show()

        //RENDER LOOP AND WINDOW SIZE UPDATER SETUP
        window.addEventListener("resize", this.resizeCanvas)
        RAF.subscribe('threeSceneUpdate', () => {this.update()})
        
        //PHYSICS WORLD INSTANCE
        const world = new World(this.scene)
        const physics = new Physics()
        physics.init(this.scene)
        physics.linkToWorld(world)
        
        RAF.subscribe('threeSceneUpdate', () => {
            physics.update()
            console.log('physics update')
            // debugger
        })
    }

    update() {
        this.renderer.render(this.scene, this.camera);
        console.log('update')
    }

    resizeCanvas() {
        this.renderer.setSize(window.innerWidth, window.innerHeight)
        this.camera.aspect = window.innerWidth / window.innerHeight
        this.camera.updateProjectionMatrix()
    }

    bind() {
        this.resizeCanvas = this.resizeCanvas.bind(this)
        this.update = this.update.bind(this)
        this.init = this.init.bind(this)
    }
}

const _instance = new MainThreeScene()
export default _instance